
import * as PropTypes from 'prop-types'
import * as ct from '../../global/controls';
import moment from 'moment';
import { ITranslationContext } from '../../../translations';
import { DateFormat, DayOfWeek } from '../../../store/pages/venues/types';
import { AnalyticsPeriod, AnalyticsPeriodSelection } from '../../../store/pages/analytics/types';
import { formatPosition } from '../../../utils/util';
import { monthNameAbbreviations } from '../../../utils/extensions';

interface PeriodSelectionProps {
    firstDayOfWeek: DayOfWeek;
    period: AnalyticsPeriod;
    dateFormat: DateFormat;
    periodChanged: (period: AnalyticsPeriod) => void;
}

const PeriodSelection = (props: PeriodSelectionProps, context: ITranslationContext) => {
    const { t } = context;
    const { period, dateFormat, firstDayOfWeek, periodChanged } = props;
    const options = Object.keys(AnalyticsPeriodSelection)
        .filter(k => typeof AnalyticsPeriodSelection[k as any] === 'number')
        .map(k => ({ key: AnalyticsPeriodSelection[k as any].toString(), name: t(`AnalyticsPeriodSelection:${k}`) }));

    const onPeriodSelected = (selectedPeriodKey: string) => {
        const periodSelection = parseInt(selectedPeriodKey);

        const period = periodSelection === AnalyticsPeriodSelection.Custom
            ? AnalyticsPeriod.custom(new Date(), new Date())
            : AnalyticsPeriod.create(periodSelection, firstDayOfWeek);

        periodChanged(period)
    }

    return <div style={{ display: 'flex'}}>
        <ct.Select
            id='reportPeriod'
            classNames='analytics-report-period-selection'
            labelKey=''
            value={({ controlId: 'reportPeriod', isValid: true, hasValidation: false, value: period.period.toString() })}
            options={options}
            renderSelectedOption={o => `${o.name} ${formatPeriod(parseInt(o.key), period.from, period.to, dateFormat, t)}`}
            callback={onPeriodSelected}
            minimal={true} />
        {period.period === AnalyticsPeriodSelection.Custom
            ? <ct.DateRangePicker
                id='reportPeriodDateSelection'
                labelKey=''
                value={({ controlId: 'reportPeriodDateSelection', isValid: true, hasValidation: false, value: { from: moment(period.from), to: moment(period.to)  } }) }
                callback={val => periodChanged(AnalyticsPeriod.custom(val.from ? val.from.toDate() : new Date(), val.to ? val.to.toDate() : new Date()))}
                timeFormat={false}
                minimal={true} />
            : null}
    </div>
}

const formatPeriod = (period: AnalyticsPeriodSelection, from: Date, to: Date, dateFormat: DateFormat, t: (val: string) => string) => {
    if (period === AnalyticsPeriodSelection.Custom) {
            return "";
    }

    return `(${formatDatePeriod(from, to, dateFormat, t)})`;
}

const formatDatePeriod = (from: Date, to: Date, dateFormat: DateFormat, t: (val: string) => string) => {
    if (from.getTime() == to.getTime())
        return from.toAbbrDateString(dateFormat, t);
    if (from.getFullYear() === to.getFullYear()) {
        if (from.getMonth() === to.getMonth()) {
            return dateFormat == DateFormat.MDY
                ? `${t(monthNameAbbreviations[from.getMonth()])} ${formatPosition(from.getDate(), t)} - ${formatPosition(to.getDate(), t)} ${from.getFullYear()}`
                : `${from.getDate()} - ${to.getDate()} ${t(monthNameAbbreviations[from.getMonth()])} ${from.getFullYear()}`
        } else {
            return dateFormat == DateFormat.MDY
                ? `${t(monthNameAbbreviations[from.getMonth()])} ${formatPosition(from.getDate(), t)} - ${t(monthNameAbbreviations[to.getMonth()])} ${formatPosition(to.getDate(), t)} ${from.getFullYear()}`
                : `${from.getDate()} ${t(monthNameAbbreviations[from.getMonth()])} - ${to.getDate()} ${t(monthNameAbbreviations[to.getMonth()])} ${from.getFullYear()}`
        }
    } else {
        return `${from.toAbbrDateString(dateFormat, t)} - ${to.toAbbrDateString(dateFormat, t)}`;
    }
}

PeriodSelection.contextTypes = {
    t: PropTypes.func
}

export default PeriodSelection;